import React from 'react';

export type EditableSectionsContextState = {
  editKey: string | null;
  setEditKey: (editKey: string | null) => void;
  preprocessEditKeyChange?: (editKey: string) => Promise<void>;
  tipWidth?: number;
};

export const EditableSectionsContext = React.createContext<EditableSectionsContextState | null>(null);

export const useEditableSectionsContext = () => {
  const context = React.useContext(EditableSectionsContext);

  if (!context) {
    return {
      editKey: '',
      setEditKey: (key: string) => key,
    } as EditableSectionsContextState;
    // throw new Error('Need to use EditableSectionsContext');
  }

  return context;
};

export type EditableSectionListContextState = {
  editIndex: number;
  setEditIndex: (editIndex: number) => void;
};

export const EditableSectionListContext = React.createContext<EditableSectionListContextState | null>(null);

export const useEditableSectionListContext = () => {
  const context = React.useContext(EditableSectionListContext);

  if (!context) {
    return {
      editIndex: 0,
      setEditIndex: (index: number) => index,
    } as EditableSectionListContextState;
    // throw new Error('Need to use EditableSectionsContext');
  }

  return context;
};

export const useSectionEditRow = (rowKey?: string) => {
  const editableSectionsState = useEditableSectionsContext();

  const isEditRow = editableSectionsState?.editKey === rowKey;
  const onEditRow = () => editableSectionsState && rowKey && editableSectionsState.setEditKey(rowKey);
  const onCancelEdit = () => editableSectionsState && editableSectionsState.setEditKey(null);

  return { isEditRow, onEditRow, onCancelEdit };
};
